// extracted by mini-css-extract-plugin
export default {"ShopContainer":"Shop_ShopContainer__TfQ+5","Shopbox":"Shop_Shopbox__kqeMn","shopImg":"Shop_shopImg__XBHFW","shopPrice":"Shop_shopPrice__PPild"};